import { URL_ROOT } from "../urls";
import { useAuthSWR } from "./useAuthSWR";

// 認証されたセッションを取得する
// ユーザ情報を使うことがあれば今後使う
export default function useUser() {
    // 認証されていない場合、useAuthSWRの機能でリダイレクトされる
    useAuthSWR(`${URL_ROOT}user`, { refreshInterval: 1000 * 60 * 60 * 24 });
}
